var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-chip',{attrs:{"color":_vm.chipColor}},[_c('vs-avatar',{attrs:{"icon":_vm.icon}}),_c('span',[_vm._t("default",function(){return [_vm._v("\n            "+_vm._s(_vm.timerText)+"\n        ")]},{"text":_vm.timerText})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }